import React from 'react';

interface RecapMVPProps {
  name: string;
  votes: number;
  avatar?: string | null;
}

export default function RecapMVP({ name, votes, avatar }: RecapMVPProps) {
  const initials = name.trim().slice(0, 2).toUpperCase();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: '16px 0' }}>
      <div style={{ position: 'relative', width: 96, height: 96, borderRadius: '50%', overflow: 'hidden', background: '#222' }}>
        {avatar ? (
          <img src={avatar} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 32, fontWeight: 700 }}>
            {initials}
          </div>
        )}
        <div style={{ position: 'absolute', bottom: -8, right: -8, fontSize: 32 }} aria-label="MVP">🏆</div>
      </div>
      <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff' }}>{name}</p>
      <p style={{ margin: 0, fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>
        MVP · {votes} {votes === 1 ? 'voto' : 'votos'}
      </p>
    </div>
  );
}
